// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {FormGroup, DropDownListField, InputField} from '../../../form'
import {updateUserProducts} from '../../../../actions/userManagement'

// Icons
import {AdminIconComponent, UserIconComponent} from '../../../../media/icons/UserIconsComponent'

import './index.css'

const userIcons = {
  'TenantAdmin': <AdminIconComponent/>,
  'TenantUser': <UserIconComponent/>
}


class UpdateUserProductsForm extends Component {
  renderUserIcon () {
    return userIcons[this.props.user.role]
  }

  renderFromSelectField (name, data, className) {
    const {handleSubmit} = this.props
    return (
      <FormGroup className={className}>
        <Field
          name={name}
          data={data}
          component={DropDownListField}
          onBlur={() => handleSubmit()}
        />
      </FormGroup>
    )
  }

  render () {
    const {user} = this.props
    let userName = `${user.firstName} ${user.lastName}`
    return (
      <form className='tr update-user-products-form row' onSubmit={() => {}}>
        <div className='th col-2 user-icon'>
          {this.renderUserIcon()} <span>{userName}</span>
          <FormGroup>
            <Field
              name='userName'
              type='hidden'
              component={InputField}
              className='rw-widget-input rw-widget-container'
              value={user.userName}
            />
          </FormGroup>
        </div>
        <div className='td col-2'>
          {this.renderFromSelectField('multiDRM', ['View only', 'Admin', 'Inactive'], 'col-6')}
        </div>
      </form>
    )
  }
}

function validate () {
  let ret = {}
  return ret
}

function onSubmit (values, dispatch) {
  dispatch(updateUserProducts(values))
}

export default reduxForm({
  onSubmit: onSubmit,
  validate: validate,
})(UpdateUserProductsForm)
